module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/studio-suns_spot_04-7c212f7b67c5cf733e303ac57855b269.jpg";